import ImagePlaceholder from '../../asset/image/image-fallback.png'
import { useImageFile } from '../../hook/use-image-file'
import styles from '../../styles/fade-in.module.scss'
import React, { useState } from 'react'
import { Image, ImageProps } from 'react-bootstrap'

export const ImageFileId = (props: { fileId: string; alt?: string; className?: string } & ImageProps): React.ReactElement => {
  const { alt, fileId, className } = props
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  const { data: imageBase64, isError } = useImageFile(fileId)

  const imageSrc = isError || !imageBase64 ? ImagePlaceholder : imageBase64
  const fadeInClass = isImageLoaded ? `${styles.fadeIn} ${styles.loaded}` : styles.fadeIn

  const handleImageLoad = (): void => {
    setIsImageLoaded(true)
  }

  const handleImageError = (): void => {
    setIsImageLoaded(true)
  }

  return (
    <Image
      src={imageSrc}
      alt={alt ?? ''}
      className={`${fadeInClass} ${className || ''}`}
      onLoad={handleImageLoad}
      onError={handleImageError}
      {...props}
    />
  )
}
